import { render } from "./MutagenDisplay.vue?vue&type=template&id=24eb5796&scoped=true"
import script from "./MutagenDisplay.vue?vue&type=script&lang=js"
export * from "./MutagenDisplay.vue?vue&type=script&lang=js"

import "./MutagenDisplay.vue?vue&type=style&index=0&id=24eb5796&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24eb5796"]])

export default __exports__